module.exports = __webpack_public_path__ + "img/uluuk_logo.8a4c823d.png";